module.exports = __webpack_public_path__ + "dist/assets/99def506c4279c85933a93a9c86bd76d.svg";